module.exports = __webpack_public_path__ + "static/media/wave.cec07984.svg";